// interface icons
import SvgArrowDown from '@img/icons/interface/arrow-down.svg';
import SvgArrowRight from '@img/icons/interface/arrow-right.svg';
import SvgArrowUp from '@img/icons/interface/arrow-up.svg';
import SvgCalendarBlank from '@img/icons/interface/calendar-blank.svg';
import SvgCalendar from '@img/icons/interface/calendar.svg';
import SvgChevron from '@img/icons/interface/chevron-down.svg';
import SvgClock from '@img/icons/interface/clock.svg';
import SvgClose from '@img/icons/interface/close.svg';
import SvgCommunity from '@img/icons/interface/community.svg';
import SvgDownload from '@img/icons/interface/download.svg';
import SvgEdit from '@img/icons/interface/edit.svg';
import SvgExternal from '@img/icons/interface/external.svg';
import SvgFilters from '@img/icons/interface/filters.svg';
import SvgGlobe from '@img/icons/interface/globe.svg';
import SvgHome from '@img/icons/interface/home.svg';
import SvgLanguage from '@img/icons/interface/language.svg';
import SvgLocation from '@img/icons/interface/location.svg';
import SvgLock from '@img/icons/interface/lock.svg';
import SvgLogout from '@img/icons/interface/logout.svg';
import SvgMail from '@img/icons/interface/mail.svg';
import SvgMenu from '@img/icons/interface/menu.svg';
import SvgPhone from '@img/icons/interface/phone.svg';
import SvgPlus from '@img/icons/interface/plus.svg';
import SvgPlay from '@img/icons/interface/play.svg';
import SvgPrint from '@img/icons/interface/print.svg';
import SvgQuote from '@img/icons/interface/quote.svg';
import SvgSearch from '@img/icons/interface/search.svg';
import SvgSettings from '@img/icons/interface/settings.svg';
import SvgShare from '@img/icons/interface/share.svg';
import SvgTick from '@img/icons/interface/tick.svg';
import SvgUnlocked from '@img/icons/interface/unlocked.svg';
import SvgUser from '@img/icons/interface/user.svg';
// system icons
import SvgAdvertising from '@img/icons/system/advertising.svg';
import SvgAirQuality from '@img/icons/system/air-quality.svg';
import SvgAppleCore from '@img/icons/system/apple-core.svg';
import SvgAtomHeart from '@img/icons/system/atom-heart.svg';
import SvgAwardTick from '@img/icons/system/award-tick.svg';
import SvgAward from '@img/icons/system/award.svg';
import SvgBadgeTick from '@img/icons/system/badge-tick.svg';
import SvgBag from '@img/icons/system/bag.svg';
import SvgBarcodeSearch from '@img/icons/system/barcode-search.svg';
import SvgBattery from '@img/icons/system/battery.svg';
import SvgBinLorry from '@img/icons/system/bin-lorry.svg';
import SvgBin from '@img/icons/system/bin.svg';
import SvgBiodegradable from '@img/icons/system/biodegradable.svg';
import SvgBookmark from '@img/icons/system/bookmark.svg';
import SvgBottle from '@img/icons/system/bottle.svg';
import SvgBoxOpen from '@img/icons/system/box-open.svg';
import SvgBox from '@img/icons/system/box.svg';
import SvgBriefcase from '@img/icons/system/briefcase.svg';
import SvgBubbles from '@img/icons/system/bubbles.svg';
import SvgBulbEfficient from '@img/icons/system/bulb-efficient.svg';
import SvgBulb from '@img/icons/system/bulb.svg';
import SvgCalculator from '@img/icons/system/calculator.svg';
import SvgCalendarDelivery from '@img/icons/system/calendar-delivery.svg';
import SvgCalendarMonth from '@img/icons/system/calendar-month.svg';
import SvgCalendarNotification from '@img/icons/system/calendar-notification.svg';
import SvgCalendarSync from '@img/icons/system/calendar-sync.svg';
import SvgCalendarTick from '@img/icons/system/calendar-tick.svg';
import SvgCalendarTime from '@img/icons/system/calendar-time.svg';
import SvgCan from '@img/icons/system/can.svg';
import SvgCare from '@img/icons/system/care.svg';
import SvgCashRegister from '@img/icons/system/cash-register.svg';
import SvgCash from '@img/icons/system/cash.svg';
import SvgCash2 from '@img/icons/system/cash2.svg';
import SvgChargingPoint from '@img/icons/system/charging-point.svg';
import SvgChecklist from '@img/icons/system/checklist.svg';
import SvgChess from '@img/icons/system/chess.svg';
import SvgCleaning from '@img/icons/system/cleaning.svg';
import SvgClipboardTick from '@img/icons/system/clipboard-tick.svg';
import SvgClipboard from '@img/icons/system/clipboard.svg';
import SvgClockTime from '@img/icons/system/clock-time.svg';
import SvgClockTimer from '@img/icons/system/clock-timer.svg';
import SvgClothesClean from '@img/icons/system/clothes-clean.svg';
import SvgClothesDirty from '@img/icons/system/clothes-dirty.svg';
import SvgClothesDrying from '@img/icons/system/clothes-drying.svg';
import SvgCollect from '@img/icons/system/collect.svg';
import SvgCommunitySync from '@img/icons/system/community-sync.svg';
import SvgConnected from '@img/icons/system/connected.svg';
import SvgCopy from '@img/icons/system/copy.svg';
import SvgCountMoney from '@img/icons/system/count-money.svg';
import SvgCreditCard from '@img/icons/system/credit-card.svg';
import SvgCycling from '@img/icons/system/cycling.svg';
import SvgDeliveryExpand from '@img/icons/system/delivery-expand.svg';
import SvgDeliveryMan from '@img/icons/system/delivery-man.svg';
import SvgDeliveryNetwork from '@img/icons/system/delivery-network.svg';
import SvgDeliverySettings from '@img/icons/system/delivery-settings.svg';
import SvgDeliveryTime from '@img/icons/system/delivery-time.svg';
import SvgDelivery from '@img/icons/system/delivery.svg';
import SvgDetergent from '@img/icons/system/detergent.svg';
import SvgDirections from '@img/icons/system/directions.svg';
import SvgDirections2 from '@img/icons/system/directions2.svg';
import SvgDirections3 from '@img/icons/system/directions3.svg';
import SvgDirections4 from '@img/icons/system/directions4.svg';
import SvgDirections5 from '@img/icons/system/directions5.svg';
import SvgDirections6 from '@img/icons/system/directions6.svg';
import SvgDiscount from '@img/icons/system/discount.svg';
import SvgDocumentApproved from '@img/icons/system/document-approved.svg';
import SvgDocumentPaperclip from '@img/icons/system/document-paperclip.svg';
import SvgDocumentPay from '@img/icons/system/document-pay.svg';
import SvgDocumentPen from '@img/icons/system/document-pen.svg';
import SvgDocumentSave from '@img/icons/system/document-save.svg';
import SvgDocumentSearch from '@img/icons/system/document-search.svg';
import SvgDocumentSend from '@img/icons/system/document-send.svg';
import SvgDocumentSend2 from '@img/icons/system/document-send2.svg';
import SvgDocument from '@img/icons/system/document.svg';
import SvgDocuments from '@img/icons/system/documents.svg';
import SvgEcoFriendly from '@img/icons/system/eco-friendly.svg';
import SvgElectricCar from '@img/icons/system/electric-car.svg';
import SvgElectricCar2 from '@img/icons/system/electric-car2.svg';
import SvgEmail from '@img/icons/system/email.svg';
import SvgEye from '@img/icons/system/eye.svg';
import SvgFactory from '@img/icons/system/factory.svg';
import SvgFamilyPresent from '@img/icons/system/family-present.svg';
import SvgFamilySingle from '@img/icons/system/family-single.svg';
import SvgFamilyYoung from '@img/icons/system/family-young.svg';
import SvgFamily from '@img/icons/system/family.svg';
import SvgFarm from '@img/icons/system/farm.svg';
import SvgFile from '@img/icons/system/file.svg';
import SvgFlag from '@img/icons/system/flag.svg';
import SvgFlower from '@img/icons/system/flower.svg';
import SvgGift from '@img/icons/system/gift.svg';
import SvgGlassBroken from '@img/icons/system/glass-broken.svg';
import SvgGlobeEco from '@img/icons/system/globe-eco.svg';
import SvgGlobeHand from '@img/icons/system/globe-hand.svg';
import SvgGlobePin from '@img/icons/system/globe-pin.svg';
import SvgGlobePins from '@img/icons/system/globe-pins.svg';
import SvgGlobeTime from '@img/icons/system/globe-time.svg';
import SvgGraphBarHorizontal from '@img/icons/system/graph-bar-horizontal.svg';
import SvgGraphBars from '@img/icons/system/graph-bars.svg';
import SvgGraphBars2 from '@img/icons/system/graph-bars2.svg';
import SvgGraphDecrease from '@img/icons/system/graph-decrease.svg';
import SvgGraphIncreaseLines from '@img/icons/system/graph-increase-lines.svg';
import SvgGraphIncrease from '@img/icons/system/graph-increase.svg';
import SvgGraphLines from '@img/icons/system/graph-lines.svg';
import SvgGraphLines2 from '@img/icons/system/graph-lines2.svg';
import SvgGraphPie from '@img/icons/system/graph-pie.svg';
import SvgGreenBuilding from '@img/icons/system/green-building.svg';
import SvgGreenBuilding2 from '@img/icons/system/green-building2.svg';
import SvgGreenBulb from '@img/icons/system/green-bulb.svg';
import SvgGreenCity from '@img/icons/system/green-city.svg';
import SvgGreenCommunity from '@img/icons/system/green-community.svg';
import SvgGreenDelivery from '@img/icons/system/green-delivery.svg';
import SvgGreenEnergy from '@img/icons/system/green-energy.svg';
import SvgGreenEnergy2 from '@img/icons/system/green-energy2.svg';
import SvgGreenFactory from '@img/icons/system/green-factory.svg';
import SvgGreenHand from '@img/icons/system/green-hand.svg';
import SvgGreenHome from '@img/icons/system/green-home.svg';
import SvgGreenTag from '@img/icons/system/green-tag.svg';
import SvgGreenTechnology from '@img/icons/system/green-technology.svg';
import SvgGreenTick from '@img/icons/system/green-tick.svg';
import SvgGreenTransport from '@img/icons/system/green-transport.svg';
import SvgHandshakeTick from '@img/icons/system/handshake-tick.svg';
import SvgHandshake from '@img/icons/system/handshake.svg';
import SvgHanger from '@img/icons/system/hanger.svg';
import SvgImage from '@img/icons/system/image.svg';
import SvgInDrawer from '@img/icons/system/in-drawer.svg';
import SvgInTrayNew from '@img/icons/system/in-tray-new.svg';
import SvgInTray from '@img/icons/system/in-tray.svg';
import SvgIroning from '@img/icons/system/ironing.svg';
import SvgJar from '@img/icons/system/jar.svg';
import SvgJug from '@img/icons/system/jug.svg';
import SvgKnitting from '@img/icons/system/knitting.svg';
import SvgMarketplace from '@img/icons/system/marketplace.svg';
import SvgMeetingTime from '@img/icons/system/meeting-time.svg';
import SvgMeeting from '@img/icons/system/meeting.svg';
import SvgMobile from '@img/icons/system/mobile.svg';
import SvgMoney from '@img/icons/system/money.svg';
import SvgNetZero from '@img/icons/system/net-zero.svg';
import SvgNetwork from '@img/icons/system/network.svg';
import SvgNewspaper from '@img/icons/system/newspaper.svg';
import SvgOnlineShoppingClick from '@img/icons/system/online-shopping-click.svg';
import SvgOnlineShopping from '@img/icons/system/online-shopping.svg';
import SvgOnlineShopping2 from '@img/icons/system/online-shopping2.svg';
import SvgOrderChecked from '@img/icons/system/order-checked.svg';
import SvgOrderCollect from '@img/icons/system/order-collect.svg';
import SvgOrderPicking from '@img/icons/system/order-picking.svg';
import SvgOrderReturn from '@img/icons/system/order-return.svg';
import SvgOrderTracking from '@img/icons/system/order-tracking.svg';
import SvgPayCard from '@img/icons/system/pay-card.svg';
import SvgPayCash from '@img/icons/system/pay-cash.svg';
import SvgPeople from '@img/icons/system/people.svg';
import SvgPerson from '@img/icons/system/person.svg';
import SvgPhoneCross from '@img/icons/system/phone-cross.svg';
import SvgPhoneSpeak from '@img/icons/system/phone-speak.svg';
import SvgPhoneSpeaker from '@img/icons/system/phone-speaker.svg';
import SvgPhoneTick from '@img/icons/system/phone-tick.svg';
import SvgPinArea from '@img/icons/system/pin-area.svg';
import SvgPinDirections from '@img/icons/system/pin-directions.svg';
import SvgPinHome from '@img/icons/system/pin-home.svg';
import SvgPinMap from '@img/icons/system/pin-map.svg';
import SvgPinMobile from '@img/icons/system/pin-mobile.svg';
import SvgPinStore from '@img/icons/system/pin-store.svg';
import SvgPinStore2 from '@img/icons/system/pin-store2.svg';
import SvgPinStore3 from '@img/icons/system/pin-store3.svg';
import SvgPin from '@img/icons/system/pin.svg';
import SvgPresentation from '@img/icons/system/presentation.svg';
import SvgPuzzle from '@img/icons/system/puzzle.svg';
import SvgRating from '@img/icons/system/rating.svg';
import SvgReceieveCoin from '@img/icons/system/receieve-coin.svg';
import SvgReceipt from '@img/icons/system/receipt.svg';
import SvgRecieveMoney from '@img/icons/system/recieve-money.svg';
import SvgRecyclingBag from '@img/icons/system/recycling-bag.svg';
import SvgRecyclingBag2 from '@img/icons/system/recycling-bag2.svg';
import SvgRecyclingBin from '@img/icons/system/recycling-bin.svg';
import SvgRecyclingSack from '@img/icons/system/recycling-sack.svg';
import SvgRecycling from '@img/icons/system/recycling.svg';
import SvgRefresh from '@img/icons/system/refresh.svg';
import SvgRefresh2 from '@img/icons/system/refresh2.svg';
import SvgRotate from '@img/icons/system/rotate.svg';
import SvgSavingsGrowing from '@img/icons/system/savings-growing.svg';
import SvgSavingsJar from '@img/icons/system/savings-jar.svg';
import SvgSavingsStack from '@img/icons/system/savings-stack.svg';
import SvgScales from '@img/icons/system/scales.svg';
import SvgSearchComputer from '@img/icons/system/search-computer.svg';
import SvgSend from '@img/icons/system/send.svg';
import SvgSettingsCogs from '@img/icons/system/settings-cogs.svg';
import SvgSettingsCogs2 from '@img/icons/system/settings-cogs2.svg';
import SvgShoppingBags from '@img/icons/system/shopping-bags.svg';
import SvgShoppingBasket from '@img/icons/system/shopping-basket.svg';
import SvgShoppingCartMobile from '@img/icons/system/shopping-cart-mobile.svg';
import SvgShoppingCart from '@img/icons/system/shopping-cart.svg';
import SvgShopping from '@img/icons/system/shopping.svg';
import SvgSpeechExclamation from '@img/icons/system/speech-exclamation.svg';
import SvgSpeechLaptop from '@img/icons/system/speech-laptop.svg';
import SvgSpeechLike from '@img/icons/system/speech-like.svg';
import SvgSpeechLove from '@img/icons/system/speech-love.svg';
import SvgSpeechMobile from '@img/icons/system/speech-mobile.svg';
import SvgSpeechPending from '@img/icons/system/speech-pending.svg';
import SvgSpeechQuestion from '@img/icons/system/speech-question.svg';
import SvgStain from '@img/icons/system/stain.svg';
import SvgSupportContact from '@img/icons/system/support-contact.svg';
import SvgSync from '@img/icons/system/sync.svg';
import SvgSync2 from '@img/icons/system/sync2.svg';
import SvgTarget from '@img/icons/system/target.svg';
import SvgTarget2 from '@img/icons/system/target2.svg';
import SvgTemperature from '@img/icons/system/temperature.svg';
import SvgThinkPuzzle from '@img/icons/system/think-puzzle.svg';
import SvgThinkSettings from '@img/icons/system/think-settings.svg';
import SvgTrees from '@img/icons/system/trees.svg';
import SvgTumbleDryer from '@img/icons/system/tumble-dryer.svg';
import SvgTv from '@img/icons/system/tv.svg';
import SvgUmbrella from '@img/icons/system/umbrella.svg';
import SvgUseBin from '@img/icons/system/use-bin.svg';
import SvgVoucherScissors from '@img/icons/system/voucher-scissors.svg';
import SvgWallet from '@img/icons/system/wallet.svg';
import SvgWashingMachineOpen from '@img/icons/system/washing-machine-open.svg';
import SvgWashingMachine from '@img/icons/system/washing-machine.svg';
import SvgWashing from '@img/icons/system/washing.svg';
import SvgWasteEnergy from '@img/icons/system/waste-energy.svg';
import SvgWaterSave from '@img/icons/system/water-save.svg';
import SvgWaterSync from '@img/icons/system/water-sync.svg';
import SvgWaterTreatment from '@img/icons/system/water-treatment.svg';
import SvgWorkflow from '@img/icons/system/workflow.svg';
import SvgWringWashing from '@img/icons/system/wring-washing.svg';
// community icons
import SvgAlumni from '@img/icons/community/alumni.svg';
import SvgBuying from '@img/icons/community/buying.svg';
import SvgCEO from '@img/icons/community/ceo.svg';
import SvgCorporateAffairs from '@img/icons/community/corporate-affairs.svg';
import SvgCSR from '@img/icons/community/csr.svg';
import SvgCustomer from '@img/icons/community/customer.svg';
import SvgFinance from '@img/icons/community/finance.svg';
import SvgFood from '@img/icons/community/food.svg';
import SvgHR from '@img/icons/community/hr.svg';
import SvgLegal from '@img/icons/community/legal.svg';
import SvgOperations from '@img/icons/community/operations.svg';
import SvgProperty from '@img/icons/community/property.svg';
import SvgTechnology from '@img/icons/community/technology.svg';
import SvgTrade from '@img/icons/community/trade.svg';
// social media icons
import SvgFacebook from '@img/icons/social/facebook.svg';
import SvgInstagram from '@img/icons/social/instagram.svg';
import SvgLinkedIn from '@img/icons/social/linked-in.svg';
import SvgPinterest from '@img/icons/social/pinterest.svg';
import SvgX from '@img/icons/social/x.svg';
import SvgYouTube from '@img/icons/social/youtube.svg';
import { SocialMediaIcon } from '@stories/Components/Misc/SocialLinks/SocialLinks';
import * as React from 'react';
import { PuffLoader } from 'react-spinners';
// interface icons
export var InterfaceIcon;
(function (InterfaceIcon) {
    InterfaceIcon["ArrowDown"] = "arrow-down";
    InterfaceIcon["ArrowRight"] = "arrow-right";
    InterfaceIcon["ArrowUp"] = "arrow-up";
    InterfaceIcon["Calendar"] = "calendar";
    InterfaceIcon["CalendarBlank"] = "calendar-blank";
    InterfaceIcon["Chevron"] = "chevron";
    InterfaceIcon["Clock"] = "clock";
    InterfaceIcon["Close"] = "close";
    InterfaceIcon["Community"] = "community";
    InterfaceIcon["Download"] = "download";
    InterfaceIcon["Edit"] = "edit";
    InterfaceIcon["External"] = "external";
    InterfaceIcon["Filters"] = "filters";
    InterfaceIcon["Globe"] = "globe";
    InterfaceIcon["Home"] = "home";
    InterfaceIcon["Language"] = "language";
    InterfaceIcon["Loader"] = "loader";
    InterfaceIcon["Location"] = "location";
    InterfaceIcon["Lock"] = "lock";
    InterfaceIcon["Logout"] = "logout";
    InterfaceIcon["Mail"] = "mail";
    InterfaceIcon["Menu"] = "menu";
    InterfaceIcon["None"] = "none";
    InterfaceIcon["Phone"] = "phone";
    InterfaceIcon["Play"] = "play";
    InterfaceIcon["Plus"] = "plus";
    InterfaceIcon["Print"] = "print";
    InterfaceIcon["Quote"] = "quote";
    InterfaceIcon["Search"] = "search";
    InterfaceIcon["Settings"] = "settings";
    InterfaceIcon["Share"] = "share";
    InterfaceIcon["Tick"] = "tick";
    InterfaceIcon["Unlocked"] = "unlocked";
    InterfaceIcon["User"] = "user";
})(InterfaceIcon || (InterfaceIcon = {}));
// system icons
export var SystemIcon;
(function (SystemIcon) {
    SystemIcon["Advertising"] = "advertising";
    SystemIcon["AirQuality"] = "air-quality";
    SystemIcon["AppleCore"] = "apple-core";
    SystemIcon["AtomHeart"] = "atom-heart";
    SystemIcon["Award"] = "award";
    SystemIcon["AwardTick"] = "award-tick";
    SystemIcon["BadgeTick"] = "badge-tick";
    SystemIcon["Bag"] = "bag";
    SystemIcon["BarcodeSearch"] = "barcode-search";
    SystemIcon["Battery"] = "battery";
    SystemIcon["Bin"] = "bin";
    SystemIcon["BinLorry"] = "bin-lorry";
    SystemIcon["Biodegradable"] = "biodegradable";
    SystemIcon["Bookmark"] = "bookmark";
    SystemIcon["Bottle"] = "bottle";
    SystemIcon["Box"] = "box";
    SystemIcon["BoxOpen"] = "box-open";
    SystemIcon["Briefcase"] = "briefcase";
    SystemIcon["Bubbles"] = "bubbles";
    SystemIcon["Bulb"] = "bulb";
    SystemIcon["BulbEfficient"] = "bulb-efficient";
    SystemIcon["Calculator"] = "calculator";
    SystemIcon["CalendarDelivery"] = "calendar-delivery";
    SystemIcon["CalendarMonth"] = "calendar-month";
    SystemIcon["CalendarNotification"] = "calendar-notification";
    SystemIcon["CalendarSync"] = "calendar-sync";
    SystemIcon["CalendarTick"] = "calendar-tick";
    SystemIcon["CalendarTime"] = "calendar-time";
    SystemIcon["Can"] = "can";
    SystemIcon["Care"] = "care";
    SystemIcon["Cash"] = "cash";
    SystemIcon["Cash2"] = "cash2";
    SystemIcon["CashRegister"] = "cash-register";
    SystemIcon["ChargingPoint"] = "charging-point";
    SystemIcon["Checklist"] = "checklist";
    SystemIcon["Chess"] = "chess";
    SystemIcon["Cleaning"] = "cleaning";
    SystemIcon["Clipboard"] = "clipboard";
    SystemIcon["ClipboardTick"] = "clipboard-tick";
    SystemIcon["ClockTime"] = "clock-time";
    SystemIcon["ClockTimer"] = "clock-timer";
    SystemIcon["ClothesClean"] = "clothes-clean";
    SystemIcon["ClothesDirty"] = "clothes-dirty";
    SystemIcon["ClothesDrying"] = "clothes-drying";
    SystemIcon["Collect"] = "collect";
    SystemIcon["CommunitySync"] = "community-sync";
    SystemIcon["Connected"] = "connected";
    SystemIcon["Copy"] = "copy";
    SystemIcon["CountMoney"] = "count-money";
    SystemIcon["CreditCard"] = "credit-card";
    SystemIcon["Cycling"] = "cycling";
    SystemIcon["Delivery"] = "delivery";
    SystemIcon["DeliveryExpand"] = "delivery-expand";
    SystemIcon["DeliveryMan"] = "delivery-man";
    SystemIcon["DeliveryNetwork"] = "delivery-network";
    SystemIcon["DeliverySettings"] = "delivery-settings";
    SystemIcon["DeliveryTime"] = "delivery-time";
    SystemIcon["Detergent"] = "detergent";
    SystemIcon["Directions"] = "directions";
    SystemIcon["Directions2"] = "directions2";
    SystemIcon["Directions3"] = "directions3";
    SystemIcon["Directions4"] = "directions4";
    SystemIcon["Directions5"] = "directions5";
    SystemIcon["Directions6"] = "directions6";
    SystemIcon["Discount"] = "discount";
    SystemIcon["Document"] = "document";
    SystemIcon["DocumentApproved"] = "document-approved";
    SystemIcon["DocumentPaperclip"] = "document-paperclip";
    SystemIcon["DocumentPay"] = "document-pay";
    SystemIcon["DocumentPen"] = "document-pen";
    SystemIcon["Documents"] = "documents";
    SystemIcon["DocumentSave"] = "document-save";
    SystemIcon["DocumentSearch"] = "document-search";
    SystemIcon["DocumentSend"] = "document-send";
    SystemIcon["DocumentSend2"] = "document-send2";
    SystemIcon["EcoFriendly"] = "eco-friendly";
    SystemIcon["ElectricCar"] = "electric-car";
    SystemIcon["ElectricCar2"] = "electric-car2";
    SystemIcon["Email"] = "email";
    SystemIcon["Eye"] = "eye";
    SystemIcon["Factory"] = "factory";
    SystemIcon["Family"] = "family";
    SystemIcon["FamilyPresent"] = "family-present";
    SystemIcon["FamilySingle"] = "family-single";
    SystemIcon["FamilyYoung"] = "family-young";
    SystemIcon["Farm"] = "farm";
    SystemIcon["File"] = "file";
    SystemIcon["Flag"] = "flag";
    SystemIcon["Flower"] = "flower";
    SystemIcon["Gift"] = "gift";
    SystemIcon["GlassBroken"] = "glass-broken";
    SystemIcon["GlobeEco"] = "globe-eco";
    SystemIcon["GlobeHand"] = "globe-hand";
    SystemIcon["GlobePin"] = "globe-pin";
    SystemIcon["GlobePins"] = "globe-pins";
    SystemIcon["GlobeTime"] = "globe-time";
    SystemIcon["GraphBars2"] = "graph-bars2";
    SystemIcon["GraphBarHorizontal"] = "graph-bar-horizontal";
    SystemIcon["GraphBars"] = "graph-bars";
    SystemIcon["GraphDecrease"] = "graph-decrease";
    SystemIcon["GraphIncrease"] = "graph-increase";
    SystemIcon["GraphIncreaseLines"] = "graph-increase-lines";
    SystemIcon["GraphLines"] = "graph-lines";
    SystemIcon["GraphLines2"] = "graph-lines2";
    SystemIcon["GraphPie"] = "graph-pie";
    SystemIcon["GreenBuilding"] = "green-building";
    SystemIcon["GreenBuilding2"] = "green-building2";
    SystemIcon["GreenBulb"] = "green-bulb";
    SystemIcon["GreenCity"] = "green-city";
    SystemIcon["GreenCommunity"] = "green-community";
    SystemIcon["GreenDelivery"] = "green-delivery";
    SystemIcon["GreenEnergy"] = "green-energy";
    SystemIcon["GreenEnergy2"] = "green-energy2";
    SystemIcon["GreenFactory"] = "green-factory";
    SystemIcon["GreenHand"] = "green-hand";
    SystemIcon["GreenHome"] = "green-home";
    SystemIcon["GreenTag"] = "green-tag";
    SystemIcon["GreenTechnology"] = "green-technology";
    SystemIcon["GreenTick"] = "green-tick";
    SystemIcon["GreenTransport"] = "green-transport";
    SystemIcon["Handshake"] = "handshake";
    SystemIcon["HandshakeTick"] = "handshake-tick";
    SystemIcon["Hanger"] = "hanger";
    SystemIcon["Image"] = "image";
    SystemIcon["InDrawer"] = "in-drawer";
    SystemIcon["InTray"] = "in-tray";
    SystemIcon["InTrayNew"] = "in-tray-new";
    SystemIcon["Ironing"] = "ironing";
    SystemIcon["Jar"] = "jar";
    SystemIcon["Jug"] = "jug";
    SystemIcon["Knitting"] = "knitting";
    SystemIcon["Marketplace"] = "marketplace";
    SystemIcon["Meeting"] = "meeting";
    SystemIcon["MeetingTime"] = "meeting-time";
    SystemIcon["Mobile"] = "mobile";
    SystemIcon["Money"] = "money";
    SystemIcon["Network"] = "network";
    SystemIcon["NetZero"] = "net-zero";
    SystemIcon["Newspaper"] = "newspaper";
    SystemIcon["OnlineShopping"] = "online-shopping";
    SystemIcon["OnlineShopping2"] = "online-shopping2";
    SystemIcon["OnlineShoppingClick"] = "online-shopping-click";
    SystemIcon["OrderChecked"] = "order-checked";
    SystemIcon["OrderCollect"] = "order-collect";
    SystemIcon["OrderPicking"] = "order-picking";
    SystemIcon["OrderReturn"] = "order-return";
    SystemIcon["OrderTracking"] = "order-tracking";
    SystemIcon["PayCard"] = "pay-card";
    SystemIcon["PayCash"] = "pay-cash";
    SystemIcon["People"] = "people";
    SystemIcon["Person"] = "person";
    SystemIcon["PhoneCross"] = "phone-cross";
    SystemIcon["PhoneSpeak"] = "phone-speak";
    SystemIcon["PhoneSpeaker"] = "phone-speaker";
    SystemIcon["PhoneTick"] = "phone-tick";
    SystemIcon["Pin"] = "pin";
    SystemIcon["PinArea"] = "pin-area";
    SystemIcon["PinDirections"] = "pin-directions";
    SystemIcon["PinHome"] = "pin-home";
    SystemIcon["PinMap"] = "pin-map";
    SystemIcon["PinMobile"] = "pin-mobile";
    SystemIcon["PinStore"] = "pin-store";
    SystemIcon["PinStore2"] = "pin-store2";
    SystemIcon["PinStore3"] = "pin-store3";
    SystemIcon["Presentation"] = "presentation";
    SystemIcon["Puzzle"] = "puzzle";
    SystemIcon["Rating"] = "rating";
    SystemIcon["ReceieveCoin"] = "receieve-coin";
    SystemIcon["Receipt"] = "receipt";
    SystemIcon["RecieveMoney"] = "recieve-money";
    SystemIcon["Recycling"] = "recycling";
    SystemIcon["RecyclingBag"] = "recycling-bag";
    SystemIcon["RecyclingBag2"] = "recycling-bag2";
    SystemIcon["RecyclingBin"] = "recycling-bin";
    SystemIcon["RecyclingSack"] = "recycling-sack";
    SystemIcon["Refresh"] = "refresh";
    SystemIcon["Refresh2"] = "refresh2";
    SystemIcon["Rotate"] = "rotate";
    SystemIcon["SavingsGrowing"] = "savings-growing";
    SystemIcon["SavingsJar"] = "savings-jar";
    SystemIcon["SavingsStack"] = "savings-stack";
    SystemIcon["Scales"] = "scales";
    SystemIcon["SearchComputer"] = "search-computer";
    SystemIcon["Send"] = "send";
    SystemIcon["SettingsCogs"] = "settings-cogs";
    SystemIcon["SettingsCogs2"] = "settings-cogs2";
    SystemIcon["Shopping"] = "shopping";
    SystemIcon["ShoppingBags"] = "shopping-bags";
    SystemIcon["ShoppingBasket"] = "shopping-basket";
    SystemIcon["ShoppingCart"] = "shopping-cart";
    SystemIcon["ShoppingCartMobile"] = "shopping-cart-mobile";
    SystemIcon["SpeechExclamation"] = "speech-exclamation";
    SystemIcon["SpeechLaptop"] = "speech-laptop";
    SystemIcon["SpeechLike"] = "speech-like";
    SystemIcon["SpeechLove"] = "speech-love";
    SystemIcon["SpeechMobile"] = "speech-mobile";
    SystemIcon["SpeechPending"] = "speech-pending";
    SystemIcon["SpeechQuestion"] = "speech-question";
    SystemIcon["Stain"] = "stain";
    SystemIcon["SupportContact"] = "support-contact";
    SystemIcon["Sync"] = "sync";
    SystemIcon["Sync2"] = "sync2";
    SystemIcon["Target"] = "target";
    SystemIcon["Target2"] = "target2";
    SystemIcon["Temperature"] = "temperature";
    SystemIcon["ThinkPuzzle"] = "think-puzzle";
    SystemIcon["ThinkSettings"] = "think-settings";
    SystemIcon["Trees"] = "trees";
    SystemIcon["TumbleDryer"] = "tumble-dryer";
    SystemIcon["Tv"] = "tv";
    SystemIcon["Umbrella"] = "umbrella";
    SystemIcon["UseBin"] = "use-bin";
    SystemIcon["VoucherScissors"] = "voucher-scissors";
    SystemIcon["Wallet"] = "wallet";
    SystemIcon["Washing"] = "washing";
    SystemIcon["WashingMachine"] = "washing-machine";
    SystemIcon["WashingMachineOpen"] = "washing-machine-open";
    SystemIcon["WasteEnergy"] = "waste-energy";
    SystemIcon["WaterSave"] = "water-save";
    SystemIcon["WaterSync"] = "water-sync";
    SystemIcon["WaterTreatment"] = "water-treatment";
    SystemIcon["Workflow"] = "workflow";
    SystemIcon["WringWashing"] = "wring-washing";
})(SystemIcon || (SystemIcon = {}));
// community icons
export var CommunityIcon;
(function (CommunityIcon) {
    CommunityIcon["Alumni"] = "alumni";
    CommunityIcon["Buying"] = "buying";
    CommunityIcon["CEO"] = "ceo";
    CommunityIcon["CorporateAffairs"] = "corporate-affairs";
    CommunityIcon["CSR"] = "csr";
    CommunityIcon["Customer"] = "customer";
    CommunityIcon["Finance"] = "finance";
    CommunityIcon["Food"] = "food";
    CommunityIcon["HR"] = "hr";
    CommunityIcon["Legal"] = "legal";
    CommunityIcon["Operations"] = "operations";
    CommunityIcon["Property"] = "property";
    CommunityIcon["Technology"] = "technology";
    CommunityIcon["Trade"] = "trade";
})(CommunityIcon || (CommunityIcon = {}));
export function getSvgIcon(icon) {
    switch (icon) {
        // interface icons
        case InterfaceIcon.ArrowDown:
            return React.createElement(SvgArrowDown, null);
        case InterfaceIcon.ArrowRight:
            return React.createElement(SvgArrowRight, null);
        case InterfaceIcon.ArrowUp:
            return React.createElement(SvgArrowUp, null);
        case InterfaceIcon.Calendar:
            return React.createElement(SvgCalendar, null);
        case InterfaceIcon.CalendarBlank:
            return React.createElement(SvgCalendarBlank, null);
        case InterfaceIcon.Chevron:
            return React.createElement(SvgChevron, null);
        case InterfaceIcon.Clock:
            return React.createElement(SvgClock, null);
        case InterfaceIcon.Close:
            return React.createElement(SvgClose, null);
        case InterfaceIcon.Community:
            return React.createElement(SvgCommunity, null);
        case InterfaceIcon.Download:
            return React.createElement(SvgDownload, null);
        case InterfaceIcon.Edit:
            return React.createElement(SvgEdit, null);
        case InterfaceIcon.External:
            return React.createElement(SvgExternal, null);
        case InterfaceIcon.Filters:
            return React.createElement(SvgFilters, null);
        case InterfaceIcon.Globe:
            return React.createElement(SvgGlobe, null);
        case InterfaceIcon.Home:
            return React.createElement(SvgHome, null);
        case InterfaceIcon.Language:
            return React.createElement(SvgLanguage, null);
        case InterfaceIcon.Loader:
            return React.createElement(PuffLoader, { color: "currentColor", size: 17 });
        case InterfaceIcon.Location:
            return React.createElement(SvgLocation, null);
        case InterfaceIcon.Lock:
            return React.createElement(SvgLock, null);
        case InterfaceIcon.Logout:
            return React.createElement(SvgLogout, null);
        case InterfaceIcon.Mail:
            return React.createElement(SvgMail, null);
        case InterfaceIcon.Menu:
            return React.createElement(SvgMenu, null);
        case InterfaceIcon.None:
            return null;
        case InterfaceIcon.Phone:
            return React.createElement(SvgPhone, null);
        case InterfaceIcon.Play:
            return React.createElement(SvgPlay, null);
        case InterfaceIcon.Plus:
            return React.createElement(SvgPlus, null);
        case InterfaceIcon.Print:
            return React.createElement(SvgPrint, null);
        case InterfaceIcon.Quote:
            return React.createElement(SvgQuote, null);
        case InterfaceIcon.Search:
            return React.createElement(SvgSearch, null);
        case InterfaceIcon.Settings:
            return React.createElement(SvgSettings, null);
        case InterfaceIcon.Share:
            return React.createElement(SvgShare, null);
        case InterfaceIcon.Tick:
            return React.createElement(SvgTick, null);
        case InterfaceIcon.Unlocked:
            return React.createElement(SvgUnlocked, null);
        case InterfaceIcon.User:
            return React.createElement(SvgUser, null);
        // system icons
        case SystemIcon.Advertising:
            return React.createElement(SvgAdvertising, null);
        case SystemIcon.AirQuality:
            return React.createElement(SvgAirQuality, null);
        case SystemIcon.AppleCore:
            return React.createElement(SvgAppleCore, null);
        case SystemIcon.AtomHeart:
            return React.createElement(SvgAtomHeart, null);
        case SystemIcon.Award:
            return React.createElement(SvgAward, null);
        case SystemIcon.AwardTick:
            return React.createElement(SvgAwardTick, null);
        case SystemIcon.BadgeTick:
            return React.createElement(SvgBadgeTick, null);
        case SystemIcon.Bag:
            return React.createElement(SvgBag, null);
        case SystemIcon.BarcodeSearch:
            return React.createElement(SvgBarcodeSearch, null);
        case SystemIcon.Battery:
            return React.createElement(SvgBattery, null);
        case SystemIcon.Bin:
            return React.createElement(SvgBin, null);
        case SystemIcon.BinLorry:
            return React.createElement(SvgBinLorry, null);
        case SystemIcon.Biodegradable:
            return React.createElement(SvgBiodegradable, null);
        case SystemIcon.Bookmark:
            return React.createElement(SvgBookmark, null);
        case SystemIcon.Bottle:
            return React.createElement(SvgBottle, null);
        case SystemIcon.Box:
            return React.createElement(SvgBox, null);
        case SystemIcon.BoxOpen:
            return React.createElement(SvgBoxOpen, null);
        case SystemIcon.Briefcase:
            return React.createElement(SvgBriefcase, null);
        case SystemIcon.Bubbles:
            return React.createElement(SvgBubbles, null);
        case SystemIcon.Bulb:
            return React.createElement(SvgBulb, null);
        case SystemIcon.BulbEfficient:
            return React.createElement(SvgBulbEfficient, null);
        case SystemIcon.Calculator:
            return React.createElement(SvgCalculator, null);
        case SystemIcon.CalendarDelivery:
            return React.createElement(SvgCalendarDelivery, null);
        case SystemIcon.CalendarMonth:
            return React.createElement(SvgCalendarMonth, null);
        case SystemIcon.CalendarNotification:
            return React.createElement(SvgCalendarNotification, null);
        case SystemIcon.CalendarSync:
            return React.createElement(SvgCalendarSync, null);
        case SystemIcon.CalendarTick:
            return React.createElement(SvgCalendarTick, null);
        case SystemIcon.CalendarTime:
            return React.createElement(SvgCalendarTime, null);
        case SystemIcon.Can:
            return React.createElement(SvgCan, null);
        case SystemIcon.Care:
            return React.createElement(SvgCare, null);
        case SystemIcon.Cash:
            return React.createElement(SvgCash, null);
        case SystemIcon.Cash2:
            return React.createElement(SvgCash2, null);
        case SystemIcon.CashRegister:
            return React.createElement(SvgCashRegister, null);
        case SystemIcon.ChargingPoint:
            return React.createElement(SvgChargingPoint, null);
        case SystemIcon.Checklist:
            return React.createElement(SvgChecklist, null);
        case SystemIcon.Chess:
            return React.createElement(SvgChess, null);
        case SystemIcon.Cleaning:
            return React.createElement(SvgCleaning, null);
        case SystemIcon.Clipboard:
            return React.createElement(SvgClipboard, null);
        case SystemIcon.ClipboardTick:
            return React.createElement(SvgClipboardTick, null);
        case SystemIcon.ClockTime:
            return React.createElement(SvgClockTime, null);
        case SystemIcon.ClockTimer:
            return React.createElement(SvgClockTimer, null);
        case SystemIcon.ClothesClean:
            return React.createElement(SvgClothesClean, null);
        case SystemIcon.ClothesDirty:
            return React.createElement(SvgClothesDirty, null);
        case SystemIcon.ClothesDrying:
            return React.createElement(SvgClothesDrying, null);
        case SystemIcon.Collect:
            return React.createElement(SvgCollect, null);
        case SystemIcon.CommunitySync:
            return React.createElement(SvgCommunitySync, null);
        case SystemIcon.Connected:
            return React.createElement(SvgConnected, null);
        case SystemIcon.Copy:
            return React.createElement(SvgCopy, null);
        case SystemIcon.CountMoney:
            return React.createElement(SvgCountMoney, null);
        case SystemIcon.CreditCard:
            return React.createElement(SvgCreditCard, null);
        case SystemIcon.Cycling:
            return React.createElement(SvgCycling, null);
        case SystemIcon.Delivery:
            return React.createElement(SvgDelivery, null);
        case SystemIcon.DeliveryExpand:
            return React.createElement(SvgDeliveryExpand, null);
        case SystemIcon.DeliveryMan:
            return React.createElement(SvgDeliveryMan, null);
        case SystemIcon.DeliveryNetwork:
            return React.createElement(SvgDeliveryNetwork, null);
        case SystemIcon.DeliverySettings:
            return React.createElement(SvgDeliverySettings, null);
        case SystemIcon.DeliveryTime:
            return React.createElement(SvgDeliveryTime, null);
        case SystemIcon.Detergent:
            return React.createElement(SvgDetergent, null);
        case SystemIcon.Directions:
            return React.createElement(SvgDirections, null);
        case SystemIcon.Directions2:
            return React.createElement(SvgDirections2, null);
        case SystemIcon.Directions3:
            return React.createElement(SvgDirections3, null);
        case SystemIcon.Directions4:
            return React.createElement(SvgDirections4, null);
        case SystemIcon.Directions5:
            return React.createElement(SvgDirections5, null);
        case SystemIcon.Directions6:
            return React.createElement(SvgDirections6, null);
        case SystemIcon.Discount:
            return React.createElement(SvgDiscount, null);
        case SystemIcon.Document:
            return React.createElement(SvgDocument, null);
        case SystemIcon.DocumentApproved:
            return React.createElement(SvgDocumentApproved, null);
        case SystemIcon.DocumentPaperclip:
            return React.createElement(SvgDocumentPaperclip, null);
        case SystemIcon.DocumentPay:
            return React.createElement(SvgDocumentPay, null);
        case SystemIcon.DocumentPen:
            return React.createElement(SvgDocumentPen, null);
        case SystemIcon.Documents:
            return React.createElement(SvgDocuments, null);
        case SystemIcon.DocumentSave:
            return React.createElement(SvgDocumentSave, null);
        case SystemIcon.DocumentSearch:
            return React.createElement(SvgDocumentSearch, null);
        case SystemIcon.DocumentSend:
            return React.createElement(SvgDocumentSend, null);
        case SystemIcon.DocumentSend2:
            return React.createElement(SvgDocumentSend2, null);
        case SystemIcon.EcoFriendly:
            return React.createElement(SvgEcoFriendly, null);
        case SystemIcon.ElectricCar:
            return React.createElement(SvgElectricCar, null);
        case SystemIcon.ElectricCar2:
            return React.createElement(SvgElectricCar2, null);
        case SystemIcon.Email:
            return React.createElement(SvgEmail, null);
        case SystemIcon.Eye:
            return React.createElement(SvgEye, null);
        case SystemIcon.Factory:
            return React.createElement(SvgFactory, null);
        case SystemIcon.Family:
            return React.createElement(SvgFamily, null);
        case SystemIcon.FamilyPresent:
            return React.createElement(SvgFamilyPresent, null);
        case SystemIcon.FamilySingle:
            return React.createElement(SvgFamilySingle, null);
        case SystemIcon.FamilyYoung:
            return React.createElement(SvgFamilyYoung, null);
        case SystemIcon.Farm:
            return React.createElement(SvgFarm, null);
        case SystemIcon.File:
            return React.createElement(SvgFile, null);
        case SystemIcon.Flag:
            return React.createElement(SvgFlag, null);
        case SystemIcon.Flower:
            return React.createElement(SvgFlower, null);
        case SystemIcon.Gift:
            return React.createElement(SvgGift, null);
        case SystemIcon.GlassBroken:
            return React.createElement(SvgGlassBroken, null);
        case SystemIcon.GlobeEco:
            return React.createElement(SvgGlobeEco, null);
        case SystemIcon.GlobeHand:
            return React.createElement(SvgGlobeHand, null);
        case SystemIcon.GlobePin:
            return React.createElement(SvgGlobePin, null);
        case SystemIcon.GlobePins:
            return React.createElement(SvgGlobePins, null);
        case SystemIcon.GlobeTime:
            return React.createElement(SvgGlobeTime, null);
        case SystemIcon.GraphBars2:
            return React.createElement(SvgGraphBars2, null);
        case SystemIcon.GraphBarHorizontal:
            return React.createElement(SvgGraphBarHorizontal, null);
        case SystemIcon.GraphBars:
            return React.createElement(SvgGraphBars, null);
        case SystemIcon.GraphDecrease:
            return React.createElement(SvgGraphDecrease, null);
        case SystemIcon.GraphIncrease:
            return React.createElement(SvgGraphIncrease, null);
        case SystemIcon.GraphIncreaseLines:
            return React.createElement(SvgGraphIncreaseLines, null);
        case SystemIcon.GraphLines:
            return React.createElement(SvgGraphLines, null);
        case SystemIcon.GraphLines2:
            return React.createElement(SvgGraphLines2, null);
        case SystemIcon.GraphPie:
            return React.createElement(SvgGraphPie, null);
        case SystemIcon.GreenBuilding:
            return React.createElement(SvgGreenBuilding, null);
        case SystemIcon.GreenBuilding2:
            return React.createElement(SvgGreenBuilding2, null);
        case SystemIcon.GreenBulb:
            return React.createElement(SvgGreenBulb, null);
        case SystemIcon.GreenCity:
            return React.createElement(SvgGreenCity, null);
        case SystemIcon.GreenCommunity:
            return React.createElement(SvgGreenCommunity, null);
        case SystemIcon.GreenDelivery:
            return React.createElement(SvgGreenDelivery, null);
        case SystemIcon.GreenEnergy:
            return React.createElement(SvgGreenEnergy, null);
        case SystemIcon.GreenEnergy2:
            return React.createElement(SvgGreenEnergy2, null);
        case SystemIcon.GreenFactory:
            return React.createElement(SvgGreenFactory, null);
        case SystemIcon.GreenHand:
            return React.createElement(SvgGreenHand, null);
        case SystemIcon.GreenHome:
            return React.createElement(SvgGreenHome, null);
        case SystemIcon.GreenTag:
            return React.createElement(SvgGreenTag, null);
        case SystemIcon.GreenTechnology:
            return React.createElement(SvgGreenTechnology, null);
        case SystemIcon.GreenTick:
            return React.createElement(SvgGreenTick, null);
        case SystemIcon.GreenTransport:
            return React.createElement(SvgGreenTransport, null);
        case SystemIcon.Handshake:
            return React.createElement(SvgHandshake, null);
        case SystemIcon.HandshakeTick:
            return React.createElement(SvgHandshakeTick, null);
        case SystemIcon.Hanger:
            return React.createElement(SvgHanger, null);
        case SystemIcon.Image:
            return React.createElement(SvgImage, null);
        case SystemIcon.InDrawer:
            return React.createElement(SvgInDrawer, null);
        case SystemIcon.InTray:
            return React.createElement(SvgInTray, null);
        case SystemIcon.InTrayNew:
            return React.createElement(SvgInTrayNew, null);
        case SystemIcon.Ironing:
            return React.createElement(SvgIroning, null);
        case SystemIcon.Jar:
            return React.createElement(SvgJar, null);
        case SystemIcon.Jug:
            return React.createElement(SvgJug, null);
        case SystemIcon.Knitting:
            return React.createElement(SvgKnitting, null);
        case SystemIcon.Marketplace:
            return React.createElement(SvgMarketplace, null);
        case SystemIcon.Meeting:
            return React.createElement(SvgMeeting, null);
        case SystemIcon.MeetingTime:
            return React.createElement(SvgMeetingTime, null);
        case SystemIcon.Mobile:
            return React.createElement(SvgMobile, null);
        case SystemIcon.Money:
            return React.createElement(SvgMoney, null);
        case SystemIcon.Network:
            return React.createElement(SvgNetwork, null);
        case SystemIcon.NetZero:
            return React.createElement(SvgNetZero, null);
        case SystemIcon.Newspaper:
            return React.createElement(SvgNewspaper, null);
        case SystemIcon.OnlineShopping:
            return React.createElement(SvgOnlineShopping, null);
        case SystemIcon.OnlineShopping2:
            return React.createElement(SvgOnlineShopping2, null);
        case SystemIcon.OnlineShoppingClick:
            return React.createElement(SvgOnlineShoppingClick, null);
        case SystemIcon.OrderChecked:
            return React.createElement(SvgOrderChecked, null);
        case SystemIcon.OrderCollect:
            return React.createElement(SvgOrderCollect, null);
        case SystemIcon.OrderPicking:
            return React.createElement(SvgOrderPicking, null);
        case SystemIcon.OrderReturn:
            return React.createElement(SvgOrderReturn, null);
        case SystemIcon.OrderTracking:
            return React.createElement(SvgOrderTracking, null);
        case SystemIcon.PayCard:
            return React.createElement(SvgPayCard, null);
        case SystemIcon.PayCash:
            return React.createElement(SvgPayCash, null);
        case SystemIcon.People:
            return React.createElement(SvgPeople, null);
        case SystemIcon.Person:
            return React.createElement(SvgPerson, null);
        case SystemIcon.PhoneCross:
            return React.createElement(SvgPhoneCross, null);
        case SystemIcon.PhoneSpeak:
            return React.createElement(SvgPhoneSpeak, null);
        case SystemIcon.PhoneSpeaker:
            return React.createElement(SvgPhoneSpeaker, null);
        case SystemIcon.PhoneTick:
            return React.createElement(SvgPhoneTick, null);
        case SystemIcon.Pin:
            return React.createElement(SvgPin, null);
        case SystemIcon.PinArea:
            return React.createElement(SvgPinArea, null);
        case SystemIcon.PinDirections:
            return React.createElement(SvgPinDirections, null);
        case SystemIcon.PinHome:
            return React.createElement(SvgPinHome, null);
        case SystemIcon.PinMap:
            return React.createElement(SvgPinMap, null);
        case SystemIcon.PinMobile:
            return React.createElement(SvgPinMobile, null);
        case SystemIcon.PinStore:
            return React.createElement(SvgPinStore, null);
        case SystemIcon.PinStore2:
            return React.createElement(SvgPinStore2, null);
        case SystemIcon.PinStore3:
            return React.createElement(SvgPinStore3, null);
        case SystemIcon.Presentation:
            return React.createElement(SvgPresentation, null);
        case SystemIcon.Puzzle:
            return React.createElement(SvgPuzzle, null);
        case SystemIcon.Rating:
            return React.createElement(SvgRating, null);
        case SystemIcon.ReceieveCoin:
            return React.createElement(SvgReceieveCoin, null);
        case SystemIcon.Receipt:
            return React.createElement(SvgReceipt, null);
        case SystemIcon.RecieveMoney:
            return React.createElement(SvgRecieveMoney, null);
        case SystemIcon.Recycling:
            return React.createElement(SvgRecycling, null);
        case SystemIcon.RecyclingBag:
            return React.createElement(SvgRecyclingBag, null);
        case SystemIcon.RecyclingBag2:
            return React.createElement(SvgRecyclingBag2, null);
        case SystemIcon.RecyclingBin:
            return React.createElement(SvgRecyclingBin, null);
        case SystemIcon.RecyclingSack:
            return React.createElement(SvgRecyclingSack, null);
        case SystemIcon.Refresh:
            return React.createElement(SvgRefresh, null);
        case SystemIcon.Refresh2:
            return React.createElement(SvgRefresh2, null);
        case SystemIcon.Rotate:
            return React.createElement(SvgRotate, null);
        case SystemIcon.SavingsGrowing:
            return React.createElement(SvgSavingsGrowing, null);
        case SystemIcon.SavingsJar:
            return React.createElement(SvgSavingsJar, null);
        case SystemIcon.SavingsStack:
            return React.createElement(SvgSavingsStack, null);
        case SystemIcon.Scales:
            return React.createElement(SvgScales, null);
        case SystemIcon.SearchComputer:
            return React.createElement(SvgSearchComputer, null);
        case SystemIcon.Send:
            return React.createElement(SvgSend, null);
        case SystemIcon.SettingsCogs:
            return React.createElement(SvgSettingsCogs, null);
        case SystemIcon.SettingsCogs2:
            return React.createElement(SvgSettingsCogs2, null);
        case SystemIcon.Shopping:
            return React.createElement(SvgShopping, null);
        case SystemIcon.ShoppingBags:
            return React.createElement(SvgShoppingBags, null);
        case SystemIcon.ShoppingBasket:
            return React.createElement(SvgShoppingBasket, null);
        case SystemIcon.ShoppingCart:
            return React.createElement(SvgShoppingCart, null);
        case SystemIcon.ShoppingCartMobile:
            return React.createElement(SvgShoppingCartMobile, null);
        case SystemIcon.SpeechExclamation:
            return React.createElement(SvgSpeechExclamation, null);
        case SystemIcon.SpeechLaptop:
            return React.createElement(SvgSpeechLaptop, null);
        case SystemIcon.SpeechLike:
            return React.createElement(SvgSpeechLike, null);
        case SystemIcon.SpeechLove:
            return React.createElement(SvgSpeechLove, null);
        case SystemIcon.SpeechMobile:
            return React.createElement(SvgSpeechMobile, null);
        case SystemIcon.SpeechPending:
            return React.createElement(SvgSpeechPending, null);
        case SystemIcon.SpeechQuestion:
            return React.createElement(SvgSpeechQuestion, null);
        case SystemIcon.Stain:
            return React.createElement(SvgStain, null);
        case SystemIcon.SupportContact:
            return React.createElement(SvgSupportContact, null);
        case SystemIcon.Sync:
            return React.createElement(SvgSync, null);
        case SystemIcon.Sync2:
            return React.createElement(SvgSync2, null);
        case SystemIcon.Target:
            return React.createElement(SvgTarget, null);
        case SystemIcon.Target2:
            return React.createElement(SvgTarget2, null);
        case SystemIcon.Temperature:
            return React.createElement(SvgTemperature, null);
        case SystemIcon.ThinkPuzzle:
            return React.createElement(SvgThinkPuzzle, null);
        case SystemIcon.ThinkSettings:
            return React.createElement(SvgThinkSettings, null);
        case SystemIcon.Trees:
            return React.createElement(SvgTrees, null);
        case SystemIcon.TumbleDryer:
            return React.createElement(SvgTumbleDryer, null);
        case SystemIcon.Tv:
            return React.createElement(SvgTv, null);
        case SystemIcon.Umbrella:
            return React.createElement(SvgUmbrella, null);
        case SystemIcon.UseBin:
            return React.createElement(SvgUseBin, null);
        case SystemIcon.VoucherScissors:
            return React.createElement(SvgVoucherScissors, null);
        case SystemIcon.Wallet:
            return React.createElement(SvgWallet, null);
        case SystemIcon.Washing:
            return React.createElement(SvgWashing, null);
        case SystemIcon.WashingMachine:
            return React.createElement(SvgWashingMachine, null);
        case SystemIcon.WashingMachineOpen:
            return React.createElement(SvgWashingMachineOpen, null);
        case SystemIcon.WasteEnergy:
            return React.createElement(SvgWasteEnergy, null);
        case SystemIcon.WaterSave:
            return React.createElement(SvgWaterSave, null);
        case SystemIcon.WaterSync:
            return React.createElement(SvgWaterSync, null);
        case SystemIcon.WaterTreatment:
            return React.createElement(SvgWaterTreatment, null);
        case SystemIcon.Workflow:
            return React.createElement(SvgWorkflow, null);
        case SystemIcon.WringWashing:
            return React.createElement(SvgWringWashing, null);
        // community icons
        case CommunityIcon.Alumni:
            return React.createElement(SvgAlumni, null);
        case CommunityIcon.Buying:
            return React.createElement(SvgBuying, null);
        case CommunityIcon.CEO:
            return React.createElement(SvgCEO, null);
        case CommunityIcon.CorporateAffairs:
            return React.createElement(SvgCorporateAffairs, null);
        case CommunityIcon.CSR:
            return React.createElement(SvgCSR, null);
        case CommunityIcon.Customer:
            return React.createElement(SvgCustomer, null);
        case CommunityIcon.Finance:
            return React.createElement(SvgFinance, null);
        case CommunityIcon.Food:
            return React.createElement(SvgFood, null);
        case CommunityIcon.HR:
            return React.createElement(SvgHR, null);
        case CommunityIcon.Legal:
            return React.createElement(SvgLegal, null);
        case CommunityIcon.Operations:
            return React.createElement(SvgOperations, null);
        case CommunityIcon.Property:
            return React.createElement(SvgProperty, null);
        case CommunityIcon.Technology:
            return React.createElement(SvgTechnology, null);
        case CommunityIcon.Trade:
            return React.createElement(SvgTrade, null);
        // social media icons
        case SocialMediaIcon.Instagram: {
            return React.createElement(SvgInstagram, null);
        }
        case SocialMediaIcon.Facebook: {
            return React.createElement(SvgFacebook, null);
        }
        case SocialMediaIcon.LinkedIn: {
            return React.createElement(SvgLinkedIn, null);
        }
        case SocialMediaIcon.Pinterest: {
            return React.createElement(SvgPinterest, null);
        }
        case SocialMediaIcon.X: {
            return React.createElement(SvgX, null);
        }
        case SocialMediaIcon.YouTube: {
            return React.createElement(SvgYouTube, null);
        }
        default: {
            return null;
        }
    }
}
